<template>
  <el-dropdown :size="size" trigger="click" class="international" @command="changeLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文</el-dropdown-item>
      <el-dropdown-item :disabled="language==='th'" command="th">ภาษาไทย</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

export default {
  props:{
    size: {
      default: 'small',
      type: String
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.commit('app/setLanguage', lang)
      window.location.reload()
    }
  }
}
</script>
<style scoped>
.international{
  padding-right: 15px;
}
  .international-icon {
    font-size: 18px !important;
    cursor: pointer;
    vertical-align: middle;
  
  }
</style>

